// Copyright ©️ 2026 eVolve MEP, LLC

import { strongEntries } from './strongEntries';

/** Returns `Pick<T, K>`, carrying over only the picked keys that are actually present on `obj`. */
export const pick = <T extends object, K extends keyof T>(obj: T, keys: readonly K[]): Pick<T, K> =>
  // TypeScript cannot correlate each key with its own value type through `fromEntries`, hence the cast
  Object.fromEntries(strongEntries(obj).filter(([key]) => keys.includes(key as K))) as Pick<T, K>;
